import React from 'react';
import {connect} from 'react-redux';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import { sortedQuestions } from '../reducer';
import { withRouter } from 'react-router'
import { Link } from 'react-router';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {createTranslation, saveTranslationMetadata, fetchTranslation} from '../actions/translation'
import {adminCardStyle} from '../containers/AdminHomepage';
import generateID from '../reducer/generateID';
import {pushTranslation} from '../actions/sync';
import Checkbox from 'material-ui/Checkbox';;


const disabledAdminCardStyle = {
  ...adminCardStyle,
  opacity: 0.5,
  pointerEvents: "none"
}

class TrAdminHomepage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      trID: -1
    }
  }

  render() {

    return  (
      <div>
        <Card style={adminCardStyle}>
          <CardHeader title="Translations" />
          <CardText> Welcome to the translations admin section.</CardText>
        </Card>
        <Card style={adminCardStyle}>
          <CardHeader title="Choose Translation" />
          <CardText>
            <DropDownMenu
              style={{width: 400}}
              value={this.state.trID}
              onChange={this.onDropDownMenuChange.bind(this)}
            >
              <MenuItem value={-1} primaryText="Choose Translation:" />
              {this.props.translationList.map(lang => <MenuItem key={lang.id} value={lang.id} primaryText={lang.title} />)}
            </DropDownMenu>
            {(this.state.trID !== -1) ? <div style={{marginLeft:25}}>
              ID: {this.props.translationList.find(t => t.id === this.state.trID).id}<br/>
              Published: {this.props.translationList.find(t => t.id === this.state.trID).published.toString()}<br/><br/>


            </div> : null}
            <div style={{marginLeft:24}}>
              <RaisedButton label="Edit Details" onClick={this.handleEditTranslation.bind(this)} disabled={this.state.trID === -1} style={{marginRight:5}}/>
              <RaisedButton label="Create New" onClick={this.handleNewTranslation.bind(this)} />
            </div>
            {/*on create new;
              -create skeleton language obj in state - title with empty arrays for questions and categories*/}
              { this.state.openNew ? <NewTranslationModal {...this.state.openNew} onClose={this.handleClose.bind(this)} onSubmit={this.handleSubmitFromHomePage.bind(this)} /> : null }
              { this.state.editTr ? <EditTranslationModal {...this.state.editTr} onClose={this.handleClose.bind(this)} onSubmit={this.handleEditSubmitFromHomePage.bind(this)} /> : null }
          </CardText>
        </Card>
        <Card style={this.state.trID === -1 ? disabledAdminCardStyle : adminCardStyle}>
          <CardHeader title="Categories" />
          <CardText>
            <RaisedButton label="See full list" containerElement={<Link to={"/admin/translation/" + this.state.trID + "/categories"} />} />
          </CardText>
        </Card>
        <Card style={this.state.trID === -1 ? disabledAdminCardStyle : adminCardStyle}>
          <CardHeader title="Questions" />
          <CardText>
            <RaisedButton label="See full list" containerElement={<Link to={"/admin/translation/" + this.state.trID + "/questions"} />} />
          </CardText>
        </Card>
      </div>
    );
  }

  onDropDownMenuChange(event, index, value){
    this.setState({trID:value})
    let translation = this.props.translations.find(t => t.id === value)
    if(value !== -1 && !translation){
      this.props.fetchTranslation(value)
    }
  }

  handleNewTranslation() {
    this.setState({
      openNew: {
        id: generateID()
      }
    });
  }

  handleEditTranslation() {
    let translation = this.props.translations.find(t => t.id === this.state.trID)
    this.setState({
      editTr:{
        id: this.state.trID,
        title: translation.title,
        published: translation.published ? translation.published : false
       }
    });
  }

  handleClose() {
    this.setState({openNew: null, editTr:null});
  }

  handleSubmitFromHomePage(props) {
    let attrs = {
      title: props.title, //use props passed, not from parent (this)
      id: props.id
    };

    this.setState({openNew: null, trID: props.id});
    this.props.onCreateTr(attrs);
  }

  handleEditSubmitFromHomePage(props){
    let attrs = {
      title: props.title,
      published: props.published
    }
    this.props.onEditTrMetadata(props.id, attrs)
    this.handleClose()
  }
}

class NewTranslationModal extends React.Component {

  constructor(props) {
    super()
    this.state = {
      title: props.title || ""
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  render() {

    let actions = [
      <FlatButton
        label="Cancel"
        primary={false}
        onClick={this.props.onClose}
      />,
      <RaisedButton
        label="Submit"
        primary={true}
        disabled={!this.state.title.length}
        onClick={this.handleSubmit}
      />
    ];

    return (
      <Dialog
        title={"Add New Translation"}
        actions={actions}
        modal={true}
        open={true}
      >
        <TextField ref="trName" id={"trName" + this.props.id} defaultValue={this.state.title} onChange={this.handleTitleChange} floatingLabelText="Title" onKeyDown={this.handleKeyDown} />
      </Dialog>
    );
  }

  handleSubmit() {
    this.props.onSubmit({
      title: this.state.title,
      id: this.props.id
    })
  }

  handleTitleChange(el, value) {
    this.setState({title: value});
  }

  handleKeyDown(e, v) {
    //BJS dont want to allow enter to submit
    // if (e.keyCode === 13) {
    //   this.setState({title: this.refs.trName.getValue()});
    //   this.handleSubmit();
    // }
  }
}

class EditTranslationModal extends React.Component {

  constructor(props) {
    super()
    this.state = {
      title: props.title || "",
      published: props.published || false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTitleChange = this.handleTitleChange.bind(this);
  //  this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  render() {

    let actions = [
      <FlatButton
        label="Cancel"
        primary={false}
        onClick={this.props.onClose}
      />,
      <RaisedButton
        label="Submit"
        primary={true}
        disabled={!this.state.title.length}
        onClick={this.handleSubmit}
      />
    ];

    return (
      <Dialog
        title={"Edit Translation"}
        actions={actions}
        modal={true}
        open={true}
      >
        <TextField ref="trName" id={"trName" + this.props.id} defaultValue={this.state.title} floatingLabelText="Title" onChange={this.handleTitleChange} />
        <Checkbox ref="trPubChkBox" id={"trPubChkBox" + this.props.id} label="Published" checked={this.state.published} onCheck={this.handlePubCheck.bind(this)} />
      </Dialog>
    );
  }

  handleSubmit() {
    this.props.onSubmit({
      title: this.state.title,
      id: this.props.id,
      published: this.state.published
    })
  }

  handleTitleChange(el, value) {
    this.setState({title: value});
  }

  handlePubCheck(){
    this.setState({
      published: !this.state.published
    })
  }
}


let mapStateToProps = (state) => {
  return {
    questions: sortedQuestions(state),
    translationList: state.translationList,
    translations: state.translations
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onCreateTr: (props) => {
      dispatch(createTranslation(props))
      dispatch(pushTranslation(props.id, true))
    },
    onEditTrMetadata: (trID, props) => {
      dispatch(saveTranslationMetadata(trID, props))
      dispatch(pushTranslation(trID, false))
    },
    fetchTranslation: (id) => dispatch(fetchTranslation(id))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TrAdminHomepage));
